export enum HistogeneticsEntityType {    
    VoucherHolder = 1,
    Donor = 2,
    Recipient = 3
}